export default __webpack_public_path__ + "static/media/userPlaceholderAvatar.dd54cd4c.svg";